import React, { useContext } from 'react'
import { DeleteAction } from './delete-action'
import { PureQueryOptions } from 'apollo-client'
import { Role } from '@contrast-security-inc/base-types'
import { RowActionList } from '../../../legacy-design-system/grid'
import { ModifyServerTagsAction } from './tag-action'
import { ModifyDiagnosticCollectionAction } from './diagnostic-collection-action'
import {
  ModifySingleServerSettingsAction,
  ServersGridFilters
} from './server-settings-action'
import { AgentFeature } from '../../agent-features'
import { useQueryClient } from 'react-query'
import { refreshAndInvalidateVrLicenseQueries } from './shared'
import { SplitContext } from '../../../ng/splitio-wrapper'
import { ConfirmationRoleActionProps } from '../../../legacy-design-system/action/confirmation-role-action'

interface Server {
  readonly id: string
  readonly name: string
  readonly tags: string[]
  readonly diagnosticCollectionEnabled: boolean
}

interface ServerActionPropsCommon
  extends Pick<ConfirmationRoleActionProps, 'size'> {
  readonly organizationID: string
  readonly organizationRole: Role
  readonly isFreemium: boolean
  readonly refetchQueries: PureQueryOptions[]
  readonly refresh: () => Promise<any>

  /**
   * True if the current user is a Protect user
   */
  readonly protect: boolean

  /**
   * The current organization's available agent features
   */
  readonly agentFeatures: AgentFeature[]
}

export interface ServerActionProps extends ServerActionPropsCommon {
  readonly server: Server
}

export interface ServerBulkActionProps extends ServerActionPropsCommon {
  readonly servers: Server[]
}

export interface ServerBulkActionWithFiltersProps
  extends ServerBulkActionProps {
  readonly filters: ServersGridFilters
}

export function ServerRowActionList({
  server,
  organizationRole,
  refresh,
  ...props
}: ServerActionProps) {
  const queryClient = useQueryClient()
  const { isSplitTreatmentOn } = useContext(SplitContext)
  const diagnosticCollectionFeatureFlagEnabled = isSplitTreatmentOn(
    'TS-26669_agent_diagnostic_service'
  )
  return (
    <RowActionList>
      <ModifyDiagnosticCollectionAction
        organizationRole={organizationRole}
        diagnosticFeatureEnabled={diagnosticCollectionFeatureFlagEnabled}
        server={server}
        refresh={refresh}
        {...props}
      />
      <ModifyServerTagsAction
        organizationRole={organizationRole}
        servers={[server]}
        refresh={refresh}
        {...props}
      />
      <ModifySingleServerSettingsAction
        organizationRole={organizationRole}
        server={server}
        refresh={refresh}
        {...props}
      />
      <DeleteAction
        server={server}
        organizationRole={organizationRole}
        refresh={() =>
          refreshAndInvalidateVrLicenseQueries({ queryClient, refresh })
        }
        {...props}
      />
    </RowActionList>
  )
}
